import React from "react";
import { Commet } from "react-loading-indicators";

const CommonLoader = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.3)", // 👈 semi-transparent black
        zIndex: 1050, // above other elements
      }}
    >
      <Commet color="#852e59" size="medium" text="" textColor="" />
    </div>
  );
};

export default CommonLoader;
